import { connect } from 'react-redux';
import {
    getMergeTemplatesBegin,
    mergeDocumentsBegin,
    getPrintDocumentsHistoryListBegin,
} from '../../store/actions/license.actions';
import {
    getMergeTemplatesList,
    getMergeTemplatesLoadingStatus,
    getPrintDocumentsHistoryList,
    getPrintDocumentsHistoryLoading,
    getLoadMoreDocuments,
} from '../../store/selectors/license.selectors';
import PrintDocuments from './PrintDocuments';

const mapStateToProps = (state: any) => {
    const isLoading = getMergeTemplatesLoadingStatus(state);
    const mergeTemplatesList = getMergeTemplatesList(state);
    const printDocumentsHistoryList = getPrintDocumentsHistoryList(state);
    const printDocumentsHistoryLoading = getPrintDocumentsHistoryLoading(state);
    const hasMore = getLoadMoreDocuments(state);
    return {
        isLoading,
        mergeTemplatesList,
        printDocumentsHistoryList,
        printDocumentsHistoryLoading,
        hasMore,
    };
};

const mapDispatchToProps = {
    getMergeTemplates: getMergeTemplatesBegin,
    mergeDocuments: mergeDocumentsBegin,
    getPrintDocumentsHistoryList: getPrintDocumentsHistoryListBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintDocuments);
